exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.buttonList[data-v-5b84da94] {\r\n  position: fixed;\r\n  bottom: 8px;\r\n  left: 0;\r\n  right: 0;\r\n  margin: auto;\r\n  text-align: center;\r\n  display: block !important;\n}\r\n", ""]);

// exports
